import usePlaceholder from 'articleEditor/hooks/usePlaceholder';
import {
  basicBlockActions,
  getTransformBlockActions,
} from 'articleEditor/utils/actions';
import { findNodePath } from 'lib-knowledge-document-structure/plate/common';
import { useMyEditorRef } from 'lib-knowledge-document-structure/plateHooks';
import { MyParagraphElement } from 'lib-knowledge-document-structure/plateTypes';
import { RenderElementProps } from 'lib-knowledge-document-structure/slate/react';
import { useMemo } from 'react';

import s from '../baseBlock/block.module.scss';
import SortableBlockWrapper from '../baseBlock/sortableBlockWrapper';

type Props = RenderElementProps & {
  element: MyParagraphElement;
};

export default function ParagraphBlock({
  element,
  attributes,
  children,
}: Props): JSX.Element {
  const editor = useMyEditorRef();
  const path = findNodePath(editor, element);

  // Doing this because we don't want the shortcut menu to work inside another block.
  const placeholder = usePlaceholder({
    placeholder: (path || []).length > 1 ? '' : "Type '/' for commands",
    element,
  });

  const blockActions = useMemo(
    () => [...basicBlockActions, ...getTransformBlockActions(element.type)],
    [element.type],
  );

  return (
    <SortableBlockWrapper
      // className={s['blockText']}
      element={element}
      blockActions={blockActions}
    >
      <div
        {...attributes}
        className={s['blockContent']}
        data-placeholder={placeholder}
      >
        {children}
      </div>
    </SortableBlockWrapper>
  );
}
